/**
 * Etiqueta de DESTINO de un programa o recetario: a quién se le asignó de verdad.
 *
 * Hasta ahora la card mostraba un chip "General" que en realidad era el campo `type` del programa
 * (General o Específico), nada que ver con la asignación. Como el destino real solo aparecía en
 * letra pequeña, un programa asignado a un cliente y al plan Active Plus seguía anunciándose como
 * "General" y parecía que no se podía quitar.
 *
 * El backend manda las etiquetas ya armadas y en español ('Todos', 'Plan: X'), así que aquí se
 * reconstruyen a partir de `user_id` / `plan_id`, que sí son neutros, para poder traducirlas. El
 * nombre propio del cliente se respeta tal cual llega.
 */

/** Destino sin asignaciones: el contenido no le llega a nadie todavía. */
export const UNASSIGNED = 'unassigned';

/**
 * Resume las asignaciones en lo que debe pintar el chip.
 *
 * @param {Array<{id: string, label: string, user_id: ?string, plan_id: ?string}>} assignments
 * @param {Function} t función de i18next
 * @returns {{ label: string, extra: number, tone: 'gold'|'muted' }}
 */
export const getAssignmentSummary = (assignments, t) => {
  const list = Array.isArray(assignments) ? assignments : [];

  if (list.length === 0) {
    return {
      label: t('assignedToNobody', { ns: 'nutrition', defaultValue: 'Sin asignar' }),
      extra: 0,
      tone: 'muted'
    };
  }

  // "A todos" manda sobre el resto: si el contenido es visible para todo el mundo, detallar
  // además un cliente concreto solo confunde.
  const general = list.find((a) => !a.user_id && !a.plan_id);
  if (general) {
    return {
      label: t('assignedToAll', { ns: 'nutrition', defaultValue: 'Todos' }),
      extra: 0,
      tone: 'gold'
    };
  }

  const [first] = list;
  const label = first.plan_id
    ? t('assignedToPlan', {
        ns: 'nutrition',
        plan: String(first.label || '').replace(/^Plan:\s*/i, ''),
        defaultValue: 'Plan: {{plan}}'
      })
    : first.label;

  return { label, extra: list.length - 1, tone: 'gold' };
};
